import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'sp-bottom-nav-bar',
	template: `<sp-nav-tabs role="navigation"></sp-nav-tabs>`,
	styleUrls: ['./bottom-nav-bar.component.scss'],
	host: {
		'[class.contained]': 'isContained',
	},
})
export class BottomNavBarComponent {
	@Input() isContained = false;
}
